import { SPORT_BASE, NAV_CONTROL } from "../services/globalVars";
import { ConfirmModel, Timestamp, Sleep } from "./utils";
import { stopAllClocks, clean_last_message, endMatchPrompt, trigger_quick_sync } from "../sport/sport-function";
import DBHandler from "../index-db/db-handler";
import { GLOBAL_VARS } from "../services/globalVars";

const dbHandler = DBHandler();


class SessionStorage {
   court  = null;
   hot_load  = null;

   constructor() {
      this.court = sessionStorage.getItem('court');
      this.hot_load = sessionStorage.getItem('hot-load');
   }

   save = () => {
      sessionStorage.setItem('court', this.court);
      sessionStorage.setItem('hot-load', this.hot_load);
   }

   clear = () => {
      sessionStorage.removeItem('court');
      sessionStorage.removeItem('hot-load');
   }


   set_court = (court) => {
      this.court = court;
      this.save();
   }
   set_hot_load = (hot_load) => {
      this.hot_load = hot_load;
      this.save();
   }
   
   get_court = () => {
      return this.court;
   }
   get_hot_load = () => {
      return this.hot_load;
   }
}





const beforeHotLoad = () => {
   return new Promise(async (resolve) => {
      try {
         console.warn('\n\n ______beforeHotLoad______ \n\n');
        
         // Not sure if this is needed, should only try to load hot loaded matches
         // console.log('isActiveMatchRunning: ', isActiveMatchRunning());
         // if (isActiveMatchRunning()) {
         //    // TODO Get user to clean match
         // }
         // const account_data = await this.get_account_data();
         // console.log('account_data: ', account_data);
         // await this.db_handler.update_settings({
         //    setting_id: 1,
         //    sport: sport_result.name,
         //    free_app: false
         // });

        resolve(true);
      } catch (error) {
         console.error('ERROR - beforeHotLoad: ', error);
         resolve(false);
      }
   });
}


const clear_hot_load = () => {
   return new Promise(async (resolve) => {
      try {
         console.log('>>> clear_hot_load <<<');
         const matches = await dbHandler.loadAllMatches(m => m.hot_load === true);
         for (let index = 0; index < matches.length; index++) {
            const match = matches[index];
            await dbHandler.deleteMatch(match.id);
         }
         await dbHandler.delete_account(10);
         await dbHandler.delete_club(10);
         await dbHandler.delete_sync(10);
         await dbHandler.delete_app_state(10);
         GLOBAL_VARS.session_storage.clear();

         console.log('>>> clear_hot_load completed <<<');
         resolve(true);
      } catch (error) {
         console.error('ERROR - clear_hot_load: ', error);
         resolve(false);
      }
   });
}




const isActiveMatchRunning = () => {
   return SPORT_BASE.sport_object.scoring.state.match.match_state !== 'match_cleared' && SPORT_BASE.sport_object.scoring.state.match.match_state !== 'match_won';
}



const Handle_Game_Change = async (matchSettings, type = 'new', match_code = null, push_match = null, match_players = null) => {
   return new Promise(async (resolve) => {
      // console.log('>>> Handle_Game_Change <<<');
      // console.log('type: ', type);
      // console.log('matchSettings: ', matchSettings);
      // console.log('game_state: ', SPORT_BASE.sport_object.game_state);


      // >>> This is need to force a refresh of the app state
      await dbHandler.update_app_state({ update: Timestamp() });
      await Sleep(250);

      if (type === 'mod') {
         if (SPORT_BASE.sport_object.game_state === 'running' || SPORT_BASE.sport_object.game_state === 'warmup') {
            if (SPORT_BASE.sport_object.scoring.state.match.games.length === 1) {
               // console.log('Check: ', SPORT_BASE.sport_object.scoring.state.match);
               // console.log('Mod Match....', matchSettings);
               SPORT_BASE.saveGameState().then((result) => {
                  SPORT_BASE.modMatch(matchSettings).then((result) => {
                     if (result) {
                        ConfirmModel({
                           title: `Update Successful`,
                           text: `Match has been Modified`,
                           confirmButtonText: 'Ok',
                           showCancelButton: false,
                           allowOutsideClick: true,
                        }).then((result) => {
                           NAV_CONTROL.closeMainMenu();
                        });
                     } else {
                        console.error('Error updating Match');
                        ConfirmModel({
                           icon: 'error',
                           title: `Unknown Error trying to modify match`,
                           text: `Please try again`,
                           confirmButtonText: 'Ok',
                           showCancelButton: false,
                           allowOutsideClick: true,
                        });
                     }
                  });
               });
            } else {
               ConfirmModel({
                  icon: 'warning',
                  title: ``,
                  text: `Unable to modify match after the first game is complete`,
                  confirmButtonText: 'Ok',
                  showCancelButton: false,
                  allowOutsideClick: true,
               });
            }
         } else {
            ConfirmModel({
               icon: 'warning',
               title: ``,
               text: `Unable to modify match while game isn't running`,
               confirmButtonText: 'Ok',
               showCancelButton: false,
               allowOutsideClick: true,
            });
         }
         resolve(true);
      } else {
         // console.error('[DEBUG] match_state: ', SPORT_BASE);
         // // console.error('[DEBUG] match_state: ', SPORT_BASE.sport_object.scoring.state.match.id);
         // console.error('[DEBUG] match_state: ', SPORT_BASE.sport_object.scoring.state.match.match_state);
         // console.error('[DEBUG] match_state - active_game: ', SPORT_BASE.sport_object.scoring.state.match.match_state.active_game);

         const active_match_id = SPORT_BASE.sport_object.scoring.state.match.id;
         const loaded_match = await SPORT_BASE.loadMatch(active_match_id);

         // console.log('active_match_id: ', active_match_id);
         // console.log('loaded_match: ', loaded_match);

         // if (SPORT_BASE.sport_object.scoring.state.match.match_state !== 'match_won' && SPORT_BASE.sport_object.scoring.state.match.match_state !== '') {
         if (typeof loaded_match !== 'undefined' && loaded_match.match_killed === false && loaded_match.match_state !== 'match_won' && loaded_match.match_state !== '') {
            const confirmResult = await ConfirmModel({
               // icon: 'warning',
               title: `Match in Progress`,
               text: `A match is still in progress, Please Select:`,
               confirmButtonText: 'END MATCH',
               cancelButtonText: 'CONTINUE MATCH',
               denyButtonText: 'Reset match & start new match',
               cancelButtonColor: 'var(--color-primary-2)',
               denyButtonColor: 'var(--color-primary-2)',
               confirmButtonColor: 'var(--red)',

               // showDenyButton: true,
               showDenyButton: false,
               showCancelButton: true,
               allowOutsideClick: false,
            });
            if (confirmResult.isConfirmed) { // End match and assign a winner
               const result = await endMatchPrompt();
               console.warn('End match prompt closed without a winner');
               if (result === false) {
                  resolve(false);
                  return '';
               } 
            } else if (confirmResult.isDenied) { // Clear existing match & start new match
               NAV_CONTROL.closeMainMenu();
               SPORT_BASE.sport_object.scoring.state.match.match_state = 'match_cleared';
               SPORT_BASE.sport_object.scoring.scoring.update_match_state('match_cleared');
               await SPORT_BASE.saveGameState('clear_match');
               NAV_CONTROL.refreshScore('clear_match');
               
            } else if (confirmResult.isDismissed && confirmResult.dismiss === 'cancel') { // Continue previous match
               NAV_CONTROL.closeMainMenu();
               resolve(false);
               return '';
            }
         } else {
            NAV_CONTROL.closeMainMenu();
         }
         // console.log('>>>>-- matchSettings: ', matchSettings);

         await clean_last_message();
         NAV_CONTROL.appliedDefaultSettings();
         stopAllClocks().then(() => {
            SPORT_BASE.initMatch(matchSettings, match_code, push_match, match_players).then((result) => {
               // console.log('Init result: ', result);
               // console.log('Lets GOOO');
               SPORT_BASE.saveGameState('handleSubmit').then(async () => {
                  await SPORT_BASE.saveGameState('');
                  await dbHandler.update_app_state({ update: Timestamp() });
                  await Sleep(250);
                  NAV_CONTROL.refreshScore('');
                  NAV_CONTROL.refreshWarmupBlock();
                  await trigger_quick_sync('start new Match');
                  resolve(result);
               });
            });
         });
      }

   });
}




export {
   Handle_Game_Change,
   beforeHotLoad,
   SessionStorage,
   clear_hot_load
}